module.exports = __webpack_public_path__ + "static/media/xchange-header@2x.8a53dcbd.png";